import { Heading3, P } from "@ovotech/element";
import * as React from "react";
import { useStore } from "_core/store";

export const ReSendEmailConfirm = () => {
  const { customerDetails } = useStore();
  return (
    <>
      <Heading3>
        We’ve just re-sent the email to{" "}
        <span data-dd-privacy="mask">{customerDetails?.email}</span>
      </Heading3>
      <P>
        Click the link in your email in order to finish the registration
        process. Please note, it may take a few minutes for the email to come
        through.
      </P>
    </>
  );
};
